/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpRightIcon20Light = forwardRef('ArrowAUpRightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.5 3a.5.5 0 0 0 0 1H15c.09 0 .176.012.26.034L3.645 15.646a.5.5 0 0 0 .708.708L15.966 4.74A1 1 0 0 1 16 5v8.5a.5.5 0 0 0 1 0V5a2 2 0 0 0-2-2H6.5Z" })));
});
